import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly STORAGE_KEY = 'juboo_user_language';
  private readonly supportedLanguages = ['en', 'fr'];
  private readonly defaultLang = 'fr';

  constructor(private translate: TranslateService) {}

  initializeTranslation(): void {
    const savedLang = localStorage.getItem(this.STORAGE_KEY);
    const browserLang = this.getBrowserLanguage();

    let langToSet = this.defaultLang;
    if (savedLang && this.supportedLanguages.includes(savedLang)) {
      langToSet = savedLang;
    } else if (browserLang && this.supportedLanguages.includes(browserLang)) {
      langToSet = browserLang;
    }

    this.translate.setDefaultLang(this.defaultLang);
    this.translate.use(langToSet);
  }

  setLanguage(lang: string): void {
    if (this.supportedLanguages.includes(lang)) {
      this.translate.use(lang);
      localStorage.setItem(this.STORAGE_KEY, lang);
    }
  }

  getCurrentLanguage(): string {
    const lang = this.translate.currentLang || localStorage.getItem(this.STORAGE_KEY);
    return this.supportedLanguages.includes(lang ?? '') ? lang! : this.defaultLang;
  }

  private getBrowserLanguage(): string {
    const navigatorLang = navigator.language || (navigator as any).userLanguage;
    return navigatorLang ? navigatorLang.split('-')[0] : 'fr';
  }
}
